import Modal from "global/component/Genericos/Modal/Modal";
import ToasterV2 from "global/component/Genericos/Toaster/ToasterV2";
import { GlobalContext } from "global/context/Provider";
import {
  logoutAuth,
  wsPostLoginSegundoFactor,
} from "global/context/action/auth/login";
import { hideModal, showModal } from "global/context/action/modal/modal";
import { showToaster } from "global/context/action/toaster/toaster";
import { regexUserLogin } from "global/utils/expresionesRegulares";
import { useContext, useEffect, useState } from "react";
import { useHistory } from "react-router";
import {
  BtnContainer,
  BtnPrimary,
  ContainerBase,
  ContainerLogin,
  ContainerLogo,
  ContainerSignIn,
  DivideLineSection,
  InputsContainer,
  ShowPassword,
} from "./localStyle";
import { IonSpinner } from "@ionic/react";
import { SegundoFactorContext } from "_+_Portal/_-_SegundoFactor/context/provider";
import { wsGetCheckActivo } from "_+_Portal/_-_SegundoFactor/context/action/checkActivo/checkActivo";
import FactorNoHabilitado from "_+_Portal/_-_SegundoFactor/components/FactorNoHabilitado/FactorNoHabilitado";
import IngresarToken from "_+_Portal/_-_SegundoFactor/components/IngresarToken/IngresarToken";
import MantenimientoCard from "_+_Portal/_-_SegundoFactor/components/MantenimientoCard/MantenimientoCard";
import InputV1 from "_+_Portal/_-_SegundoFactor/components/InputV1/InputV1";
import HidePassIcon from "_+_Portal/_-_SegundoFactor/assets/HidePassIcon";
import ShowPassIcon from "_+_Portal/_-_SegundoFactor/assets/ShowPassIcon";
import LoginIcon from "_+_Portal/_-_SegundoFactor/assets/LoginIcon";

const Login = () => {
  const {
    authDispatch,
    authState,
    toasterDispatch,
    modalDispatch,
    modalState,
    toasterState,
    resetGlobalContext,
  } = useContext(GlobalContext);

  const { resetSegundoFactorContext } = useContext(SegundoFactorContext);
  const history = useHistory();
  let config = localStorage.getItem("config");
  let versionApk = JSON.parse(config).version;
  let mantenimiento = JSON.parse(config).mantenimiento;
  let opcResetContext = JSON.parse(config).opcResetContext;

  const [passwordShown, setPasswordShown] = useState(false);
  const [userForm, setUserForm] = useState(true);
  const [passForm, setPassForm] = useState(true);
  const [userErrForm, setUserErrForm] = useState(false);
  const [passErrForm, setPassErrForm] = useState(false);
  const [formLogin, setFormLogin] = useState({
    txtUsuario: "",
    txtPassword: "",
  });

  const onChangeUsuario = (e) => {
    if (e.target.value === "") {
      setUserErrForm(false);
      setUserForm(true);
    } else {
      if (regexUserLogin.test(e.target.value)) {
        setFormLogin({
          ...formLogin,
          txtUsuario: e.target.value.toUpperCase(),
        });
        if (e.target.value.length >= 3 && e.target.value.length <= 10) {
          setUserForm(false);
          setUserErrForm(false);
        } else {
          setUserForm(true);
          setUserErrForm(true);
        }
      } else {
        //me aseguro que no se llene nada que no valide la exp regular.
        setUserForm(true);
        setUserErrForm(true);
      }
    }
  };

  const onChangePass = (e) => {
    if (e.target.value === "") {
      setPassErrForm(false);
      setPassForm(true);
    } else {
      if (regexUserLogin.test(e.target.value)) {
        setFormLogin({
          ...formLogin,
          txtPassword: e.target.value.toUpperCase(),
        });
        if (e.target.value.length >= 3 && e.target.value.length <= 10) {
          setPassForm(false);
          setPassErrForm(false);
        } else {
          setPassForm(true);
          setPassErrForm(true);
        }
      } else {
        //me aseguro que no se llene nada que no valide la exp regular.
        setPassForm(true);
        setPassErrForm(true);
      }
    }
  };

  const onKeyPress = (e) => {
    if (!regexUserLogin.test(e.key)) {
      e.preventDefault();
    }
    if (e.target.name === "txtPassword") {
      if (e.key === "Enter") {
        userLogin();
      }
    } else if (e.key === "Enter") {
      document.getElementsByName("txtPassword")[0].focus();
    }
  };

  const showPassword = () => {
    setPasswordShown(true);
  };
  const hidePassword = () => {
    setPasswordShown(false);
  };

  const userLogin = () => {
    if (
      regexUserLogin.test(formLogin.txtUsuario) &&
      regexUserLogin.test(formLogin.txtPassword)
    ) {
      wsPostLoginSegundoFactor(formLogin)(authDispatch);
    } else {
      showToaster(
        {
          texto: "Los campos son inválidos",
          tipo: "danger",
        },
        "centroArriba"
      )(toasterDispatch);
    }
  };

  const closeModal = () => {
    hideModal()(modalDispatch);
    if (opcResetContext) {
      resetGlobalContext(0);
      resetSegundoFactorContext(0);
      history.push("/segundofactor");
    } else {
      logoutAuth()(authDispatch);
    }
  };

  useEffect(() => {
    if (opcResetContext) {
      resetGlobalContext(0);
      resetSegundoFactorContext(0);
      history.push("/segundofactor");
    } else {
      logoutAuth()(authDispatch);
    }
  }, []);

  // CODIGO DEL OTRO PROYECTO
  const { checkActivoDispatch, checkActivoState } =
    useContext(SegundoFactorContext);

  const obtenerTokenStorage = async () => {
    const itemStorage = localStorage.getItem("dtoSegundoFactor");
    const itemToken = JSON.parse(itemStorage);
    if (itemToken) {
      wsGetCheckActivo(itemToken.usuario, itemToken.token)(checkActivoDispatch);
      if (itemToken.fechaCaducidad) {
        const fechaCaducidad = new Date(itemToken.fechaCaducidad);
        const fechaHoy = new Date();
        if (fechaCaducidad < fechaHoy) {
          localStorage.removeItem("dtoSegundoFactor");
        }
      }
    }
  };

  const onClickVolver = () => {
    history.push("/");
  };

  useEffect(() => {
    obtenerTokenStorage();
    //eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (checkActivoState.checkActivo.data !== null) {
      if (checkActivoState.checkActivo.data) {
        history.push("/segundofactor/home");
      }
    }
    if (
      checkActivoState.checkActivo.data !== null &&
      checkActivoState.checkActivo.data === false
    ) {
      localStorage.removeItem("dtoSegundoFactor");
      history.push("/segundofactor");
    }
    //eslint-disable-next-line
  }, [checkActivoState.checkActivo.data]);

  useEffect(() => {
    if (authState.auth.error) {
      showModal(
        <FactorNoHabilitado mensaje={authState.auth.error.detail} />,
        "Atención",
        closeModal,
        true,
        [],
        "centro",
        true
      )(modalDispatch);
    }
    // eslint-disable-next-line
  }, [authState.auth.error]);

  useEffect(() => {
    if (authState.auth.data !== null && !authState.auth.loading) {
      if (authState.auth.data?.activar2do) {
        showModal(
          <IngresarToken password={formLogin.txtPassword} />,
          "Ingresar Código",
          closeModal,
          false,
          [],
          "centro",
          true
        )(modalDispatch);
      }
    }

    //eslint-disable-next-line
  }, [authState.auth.data]);

  return (
    <>
      {modalState.modal.show && <Modal />}
      {toasterState.toaster.show && <ToasterV2 />}
      <ContainerBase>
        <ContainerLogin>
          <ContainerLogo>
            <div>
              <img
                className="ag-login-logotype"
                src={
                  process.env.PUBLIC_URL + "/assets/images/empresa/IsoLogo.png"
                }
                alt="logo"
              ></img>
            </div>
          </ContainerLogo>
          {mantenimiento ? (
            <MantenimientoCard />
          ) : (
            <ContainerSignIn>
              <div className="rb24b">
                <p>Hola! Bienvenido :)</p>
                <span className="rb16m">Ingresá tus datos</span>
              </div>
              <DivideLineSection></DivideLineSection>
              <InputsContainer>
                <InputV1
                  inputType="text"
                  name="txtUsuario"
                  headerStr="Usuario"
                  placeholderText={"GSPI"}
                  errorStr="El usuario es inválido"
                  onChange={onChangeUsuario}
                  onKeyPress={onKeyPress}
                  maxLength="10"
                  className="rb16m"
                  checkError={userErrForm}
                  isRequired={true}
                  tabIndex="2"
                />
                <InputV1
                  headerStr="Contraseña"
                  inputType="text"
                  name="txtPassword"
                  placeholderText={"*****"}
                  errorStr="La contraseña es inválida."
                  checkError={passErrForm}
                  onChange={onChangePass}
                  onKeyPress={onKeyPress}
                  className={
                    passwordShown
                      ? "inputNumericShow inputNonScroll rb16m"
                      : "inputNumeric inputNonScroll rb16m"
                  }
                  maxLength="10"
                  isRequired={true}
                />
              <ShowPassword>
                {passwordShown === false ? (
                  <>
                    <button
                      className="ptur-loginBox-show-hideBtn"
                      onClick={() => showPassword()}
                    >
                      <HidePassIcon color="var(--color-latex30)" />
                    </button>
                  </>
                ) : (
                  <>
                    <button
                      className="ptur-loginBox-show-hideBtn"
                      onClick={() => hidePassword()}
                    >
                      <ShowPassIcon color="var(--color-latex30)" />
                    </button>
                  </>
                )}
              </ShowPassword>
              </InputsContainer>
              <BtnContainer>
                <BtnPrimary
                  disabled={userForm || passForm || authState.auth.loading}
                  className={
                    userForm || passForm ? "bgc-grey65" : "pointer bgc-primary"
                  }
                  onClick={userLogin}
                >
                  <LoginIcon />
                  <span className="ag-login-spanBtnPrimary rb18m">
                    {authState.auth.loading ? "Ingresando" : "Ingresar"}
                  </span>
                  {authState.auth.loading ? (
                    <span className="ag-login-spinner">
                      <IonSpinner name="lines" />
                    </span>
                  ) : (
                    ""
                  )}
                </BtnPrimary>
                <BtnPrimary
                  className={"pointer bgc-latex30"}
                  onClick={onClickVolver}
                >
                  <span className="ag-login-spanBtnPrimary rb18m">
                    Volver al portal
                  </span>
                </BtnPrimary>
                <div>{versionApk}</div>
              </BtnContainer>
            </ContainerSignIn>
          )}
        </ContainerLogin>
      </ContainerBase>
    </>
  );
};

export default Login;
